/**
 * /advertisers/creative-upload — advertiser creative upload (OPUS DASH-146).
 *
 * Declares the TanStack Router route and delegates rendering to
 * `AdvertiserCreativeUploadPage`. The flat-file naming convention uses dots
 * as path separators, so `advertisers.creative-upload.tsx` maps to
 * `/advertisers/creative-upload`.
 *
 * Styling per brand rules: light theme only, emerald->sky gradient heading,
 * Inter font, 6-8px rounded corners, zinc borders. No emojis, no competitor
 * names.
 *
 * NOTE: This route is NOT wired into `router.tsx` by the agent — the scaffold
 * owner (root) performs the wire-up during the merge cycle.
 */

import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "./__root";
import { AdvertiserCreativeUploadPage } from "@/features/advertiser-creative-upload/AdvertiserCreativeUploadPage";

interface AdvertiserCreativeUploadSearch {
	advertiserId?: string;
}

export const advertisersCreativeUploadRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/advertisers/creative-upload",
	validateSearch: (
		raw: Record<string, unknown>,
	): AdvertiserCreativeUploadSearch => {
		const advertiserId = raw.advertiserId;
		if (typeof advertiserId === "string" && advertiserId.trim().length > 0) {
			return { advertiserId: advertiserId.trim() };
		}
		return {};
	},
	component: AdvertiserCreativeUploadPage,
});

export default advertisersCreativeUploadRoute;

export { AdvertiserCreativeUploadPage } from "@/features/advertiser-creative-upload/AdvertiserCreativeUploadPage";
